import { Link } from "react-router-dom";
import { useState } from "react";

const testimonials = [
  {
    name: "Amber Laha",
    location: "Kudo's from the Netherlands!..",
    img: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200&auto=format&fit=crop", // Replace with your exact image path if local
    text: "I'm so happy with all of the themes, great support, could not wish for more. These people are geniuses! Kudo's from the Netherlands!..",
  },
  {
    name: "John Smith",
    location: "CEO & Founder",
    img: "/img/about/testimonial1.png",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque nisl eros, pulvinar facilisis justo mollis, auctor consequat urna.",
  },
  {
    name: "Sara Jane",
    location: "Product Manager",
    img: "/img/about/testimonial2.png",
    text: "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Proin vel ante a orci tempus eleifend.",
  },
];

const accordions = [
  {
    id: "free-delivery",
    title: "Fast Free Delivery",
    content: (
      <div className="space-y-4 text-xs md:text-sm text-gray-500 leading-relaxed">
        <p>Nam liber tempor cum soluta nobis eleifend option.</p>
        <p>
          Congue nihil imperdiet doming id quod mazim placerat facer possim
          assum. Typi non habent claritatem insitam est usus legentis in iis qui
          facit eorum claritatem. Investigationes demonstraverunt lectores
          legere me.
        </p>
        <p>
          Claritas est etiam processus dynamicus, qui sequitur mutationem
          consuetudium lectorum.
        </p>
      </div>
    ),
  },
  {
    id: "years-business",
    title: "More Than 30 Years In The Business",
    content: (
      <p className="text-xs md:text-sm text-gray-500">
        More than 30 years of excellence and premium service history details go
        here.
      </p>
    ),
  },
  {
    id: "organic-foods",
    title: "100% Organic Foods",
    content: (
      <p className="text-xs md:text-sm text-gray-500">
        Certified organic items sourced directly from sustained green
        ecosystems.
      </p>
    ),
  },
  {
    id: "shopping-strategies",
    title: "Best Shopping Strategies",
    content: (
      <p className="text-xs md:text-sm text-gray-500">
        Smart techniques to balance your health choices with flexible shopping
        options.
      </p>
    ),
  },
];

export default function AboutPage() {
  const [testimonialIdx, setTestimonialIdx] = useState(0);
  const [openAccordion, setOpenAccordion] = useState("free-delivery");

  return (
    <div className="bg-white min-h-screen font-sans antialiased">
      {/* Breadcrumb */}
      {/* <div className="bg-gray-100  ">
        <div
          className="w-full h-32 bg-cover bg-center rounded-sm relative flex items-center p-8 border border-gray-100 overflow-hidden"
          style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
        >
          <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto">
            <h2 className="text-2xl text-black mb-2"> About Us</h2>
            <Link to="/" className="hover:text-[#43a047] transition-colors">
              Home
            </Link>
            <span className="mx-2 text-gray-300">/</span>
            <span className="text-gray-600">About</span>
          </nav>
        </div>
      </div> */}
      <div className="w-full">
        <div
          className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
          style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
        >
          <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
            <h2 className="text-2xl text-black font-semibold mb-2">About Us</h2>
            <Link to="/" className="hover:text-[#43a047] transition-colors">
              Home
            </Link>
            <span className="mx-2 text-gray-300">/</span>
            <span className="text-gray-600">About</span>
          </nav>
        </div>
      </div>

      {/* About Section */}
      <section className="py-14">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="/img/about/about1.jpg"
                alt="About"
                className="w-full rounded shadow-md"
              />
            </div>
            <div>
              <div className="section-title mb-6">
                <p>Who we are</p>
                <h2>About Our Organic Store</h2>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">
                We are passionate about bringing the freshest, most natural
                organic produce directly from local farms to your table. Our
                commitment to quality means we carefully select every product.
              </p>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">
                Founded in 2015, Safira has grown from a small local store to a
                trusted name in organic food, serving thousands of happy
                customers.
              </p>
              <div className="grid grid-cols-3 gap-4 mb-6">
                {[
                  { num: "15K+", label: "Happy Customers" },
                  { num: "500+", label: "Organic Products" },
                  { num: "12+", label: "Farm Partners" },
                ].map((item) => (
                  <div
                    key={item.label}
                    className="text-center p-4 bg-gray-50 border border-gray-200"
                  >
                    <p className="text-2xl font-bold text-[#43a047]">
                      {item.num}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">{item.label}</p>
                  </div>
                ))}
              </div>
              <Link
                to="/products"
                className="inline-block bg-[#43a047] text-white px-6 py-2.5 rounded font-medium hover:bg-[#388e3c] transition-colors"
              >
                Shop Now
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <div
        className="py-14 bg-cover bg-center relative"
        style={{ backgroundImage: "url(/img/about/about-us-policy-bg.jpg)" }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative max-w-7xl mx-auto px-4 text-center">
          <div className="section-title mb-10">
            <p className="!text-white opacity-80">Our advantages</p>
            <h2 className="!text-white">Why Choose Us</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              {
                icon: "/img/about/About_icon1.png",
                title: "100% Organic",
                text: "All our products are certified organic and free from harmful chemicals.",
              },
              {
                icon: "/img/about/About_icon2.png",
                title: "Fast Delivery",
                text: "We deliver fresh products to your doorstep within 24 hours of order.",
              },
              {
                icon: "/img/about/About_icon3.png",
                title: "Best Quality",
                text: "Quality is our top priority. We ensure only the best reaches you.",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="text-white text-center p-6 border border-white/20 hover:border-[#43a047] transition-colors"
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="w-12 h-12 mx-auto mb-4 object-contain"
                />
                <h3 className="font-bold text-lg mb-2">{item.title}</h3>
                <p className="text-sm text-white/80 leading-relaxed">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Team / Services Images */}
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="section-title text-center mb-10">
            <p>Our dedicated team</p>
            <h2>Meet Our Team</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                img: "/img/about/about2.jpg",
                name: "Alice Green",
                role: "Farm Director",
              },
              {
                img: "/img/about/about3.jpg",
                name: "Bob Hart",
                role: "Quality Inspector",
              },
              {
                img: "/img/about/about4.jpg",
                name: "Carol Lee",
                role: "Delivery Manager",
              },
            ].map((m) => (
              <div key={m.name} className="text-center group">
                <div className="overflow-hidden mb-4">
                  <img
                    src={m.img}
                    alt={m.name}
                    className="w-full h-60 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <h4 className="font-bold text-gray-800">{m.name}</h4>
                <p className="text-sm text-gray-400">{m.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      {/* <section className="py-14 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="section-title text-center mb-10">
            <p>What clients say</p>
            <h2>Testimonials</h2>
          </div>
          <div className="max-w-2xl mx-auto text-center">
            <div className="mb-6">
              <img src={testimonials[testimonialIdx].img} alt="" className="w-20 h-20 rounded-full object-cover mx-auto mb-3" />
              <img src="/img/about/testimonials-icon.png" alt="" className="h-8 mx-auto mb-4 opacity-30" />
              <p className="text-gray-500 text-sm leading-relaxed italic mb-4">"{testimonials[testimonialIdx].text}"</p>
              <h4 className="font-bold text-gray-800">{testimonials[testimonialIdx].name}</h4>
              <p className="text-xs text-[#43a047]">{testimonials[testimonialIdx].location}</p>
            </div>
            <div className="flex justify-center gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setTestimonialIdx(i)}
                  className={`w-2.5 h-2.5 rounded-full ${i === testimonialIdx ? 'bg-[#43a047]' : 'bg-gray-300'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section> */}

      <hr className="border-gray-200 my-4 max-w-7xl mx-auto" />

      {/* Dynamic Content Split Section (Accordion & Testimonial Sync) */}
      <section className="py-16 max-w-7xl mx-auto px-4 bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Accordion List */}
          <div>
            <h2 className="text-2xl md:text-3xl font-medium text-gray-800 mb-8 tracking-wide">
              What Can We Do For You ?
            </h2>
            <div className="space-y-4">
              {accordions.map((acc) => {
                const isOpen = openAccordion === acc.id;
                return (
                  <div
                    key={acc.id}
                    className="border border-gray-200 rounded overflow-hidden"
                  >
                    <button
                      onClick={() => setOpenAccordion(isOpen ? "" : acc.id)}
                      className={`w-full flex justify-between items-center px-4 py-3.5 text-left text-sm font-semibold transition-all duration-200 ${
                        isOpen
                          ? "bg-[#43a047] text-white"
                          : "bg-white text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      <span>{acc.title}</span>
                      <svg
                        className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2.5"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>
                    {isOpen && (
                      <div className="p-5 bg-white border-t border-gray-100">
                        {acc.content}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Testimonial Panel Block matches image */}
          <div>
            <h2 className="text-2xl md:text-3xl font-medium text-gray-800 mb-8 tracking-wide text-center lg:text-left">
              What Our Customers Says ?
            </h2>
            <div className="bg-[#fcfcfc] border border-gray-100 rounded-sm p-8 text-center relative max-w-md mx-auto lg:mx-0">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <img
                  src={testimonials[testimonialIdx].img}
                  alt={testimonials[testimonialIdx].name}
                  className="w-20 h-20 rounded-full object-cover border-4 border-white shadow-sm"
                />
              </div>

              <div className="mt-10 mb-4 flex justify-center">
                <span className="text-[#d32f2f] text-4xl font-serif leading-none">
                  “
                </span>
              </div>

              <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-6 px-2">
                {testimonials[testimonialIdx].text}
              </p>

              <h4 className="font-bold text-gray-800 text-sm mb-6">
                {testimonials[testimonialIdx].name}
              </h4>

              {/* Slider Dots */}
              <div className="flex justify-center items-center gap-2">
                {testimonials.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setTestimonialIdx(idx)}
                    className={`w-2 h-2 rounded-full transition-colors ${
                      idx === testimonialIdx ? "bg-[#d32f2f]" : "bg-gray-200"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Complete Footer Section from Image */}
    </div>
  );
}
